/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 18:36:51
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-28 18:00:22
 */
const BASE_URL = 'lishui-gov'
import request from '@/common/api/request'
// 应用总流量趋势
export const listAppFlow = params =>
  request(BASE_URL + '/sceen/listAppFlow', { params })
// 丽水市流量占比
export const listAreaRate = params =>
  request(BASE_URL + '/sceen/listAreaRate', { params })
// 走访趋势
export const getVisitTrend = params =>
  request(BASE_URL + '/govCockpit/getVisitTrend', { params })
// 诉求量分析
export const appealCase = params =>
  request(BASE_URL + '/govCockpit/appealCase', { params })
// 码上活动列表
export const getActivityScreen = params =>
  request(BASE_URL + '/govCockpit/getActivityScreen', { params })

// 丽企大讲堂数据
export const videoCase = params =>
  request(BASE_URL + '/govCockpit/videoCase', { params })
// 丽企大讲堂数据-更多
export const videoCaseList = params =>
  request(BASE_URL + '/govCockpit/videoCaseList', { params })
// 服务券数据
export const couponCase = params =>
  request(BASE_URL + '/govCockpit/couponCase', { params })
// 服务券数据-更多
export const couponCaseSearch = params =>
  request(BASE_URL + '/govCockpit/couponCaseSearch', { params })
// 各区县流量统计-更多
export const getApplyFlow = params =>
  request(BASE_URL + '/govCockpit/getApplyFlow', { params })
// 上月活跃用户占比
export const activeUser = params =>
  request(BASE_URL + '/govCockpit/activeUser', { params })
// 上月活跃用户占比-更多
export const activeUserSearch = params =>
  request(BASE_URL + '/govCockpit/activeUserSearch', { params })
// 诉求分析更多
export const appealCaseTrend = params =>
  request(BASE_URL + '/govCockpit/appealCaseTrend', { params })
// 各区县应用占比
export const getApplyCountyRate = params =>
  request(BASE_URL + '/govCockpit/getApplyCountyRate', { params })

// 活动中心-更多
export const getActivityList = params =>
  request(BASE_URL + '/govCockpit/getActivityList', { params })
// 五企-标签列表
export const labelList = params =>
  request(BASE_URL + '/homeScreen/labelList', { params })
// 五企-标签列表
export const getLabelEntList = params =>
  request.post(BASE_URL + '/homeScreen/getLabelEntList', params)
// 五企-标签列表
export const getLabelEntList2 = params =>
  request.post(BASE_URL + '/homeScreen/getLabelEntList2', params)
// 大屏-诉求走访-统计和列表查询
export const goodsOrderList = params =>
  request(BASE_URL + '/serveInst/goodsOrderList', { params })
// 五企培育-企业诉求
export const entAppealList = params =>
  request(BASE_URL + '/appeal/entAppealList', { params })
